import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import * as React from 'react';
import { formatPartialDate } from 'Utility/date';
import { filterDocumentsByType, sortDocumentsDescending } from 'Utility/documentHandling';
import { newButton } from '../../../../utils/functions';

import type { IHistoryContext } from 'Containers/FormContextHandler';

const FormattedClassification = ({
  classification,
  fm,
}: {
  classification: IMGFA['classification'];
  fm: (id: string) => string;
}): React.JSX.Element => {
  if (typeof classification !== 'string') return <span>{'-'}</span>;

  return (
    <span>
      {classification}
      {' - '}
      {(classification.includes('a') || classification.includes('b')) &&
        fm(`diagnosis.mgravis.mgfa.opts.${classification.substring(0, classification.length - 1)}`)}{' '}
      {fm(`diagnosis.mgravis.mgfa.opts.${classification}`)}
    </span>
  );
};

const DEFAULT_DOCUMENTS: IDocumentWithTypeV2<'mgfa'>[] = [];
const MGFAHistory = ({
  documents = DEFAULT_DOCUMENTS,
  startEdit,
  fm,
}: IHistoryContext<IDocumentWithTypeV2<'mgfa'>>): React.JSX.Element => {
  const mgfaDocs = filterDocumentsByType(documents, ['mgfa']).toSorted(sortDocumentsDescending);
  return (
    <HistorySection
      headerText={fm('diagnosis.mgravis.mgfa.title')}
      newButton={startEdit ? newButton('mgfa', startEdit({}, 'mgfa'), 'general.new', undefined, true) : undefined}
      hasHistoryRows={false}
    >
      <HistoryRowListing
        documents={mgfaDocs}
        headers={
          <>
            <Item xs={2}>{fm('general.date')}</Item>
            <Item xs={10}>{fm('diagnosis.mgravis.mgfa.classification')}</Item>
          </>
        }
        contentFormat={d => (
          <>
            <Item xs={2} style={{ fontWeight: '600' }}>
              {d.date && formatPartialDate(d.date)}
            </Item>
            <Item xs={7}>
              <FormattedClassification classification={d.classification} fm={fm} />
            </Item>
            <Item xs={3}>{startEdit ? <HistoryRowControls document={d} startEdit={startEdit} /> : null}</Item>
          </>
        )}
      />
    </HistorySection>
  );
};

export default MGFAHistory;
